// extracted by mini-css-extract-plugin
module.exports = {"loading":"Loading_loading__3asI0","centrado":"Loading_centrado__3Bm94"};